import React, {useState} from 'react';
import {PASSWORDREGEX} from "../../../interfaces/Helper";
import {Box, Flex, Text} from "@chakra-ui/layout";
import {Button, FormControl, FormErrorMessage, FormLabel, Input} from "@chakra-ui/react";

function TeacherChangePassword() {
  const [newPassword, setNewPassword] = useState<string>("");
  const [retypePassword, setRetypePassword] = useState<string>("");
  const [newPasswordError, setNewPasswordError] = useState<string>("");
  const [retypePasswordError, setRetypePasswordError] = useState<string>("");
  const [eyeStatus, setEyeStatus] = useState<boolean>(true);

  function revealPassword() {
    setEyeStatus(!eyeStatus);
  }

  function onLostFocus() {
    if (!retypePassword.match(newPassword)) {
      return setRetypePasswordError("Your retyped password doesn't match the new password")
    }
    setRetypePasswordError("");
  }

  function onSubmit(e: React.FormEvent<HTMLButtonElement>) {
    e.preventDefault();
    if (newPassword === "") {
      return setNewPasswordError("Please enter a password")
    }
    setNewPasswordError("")
    if (!PASSWORDREGEX.test(newPassword)) {
      return setNewPasswordError("Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character");
    }
    setNewPasswordError("");
    if (retypePassword === "") {
      return setRetypePasswordError("Please retype your new password")
    }
    setRetypePasswordError("");
    if (!retypePassword.match(newPassword)) {
      return setRetypePasswordError("Your retyped password doesn't match the new password")
    }
    setRetypePasswordError("");
    console.log("submit button clicked");
  }

  return (
    <Flex flexDirection={"column"} bgColor={"white"} borderRadius={"30px"} p={10} m={10}>
      <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>Change Password</Text>
      <Flex flexDirection={"column"} w={"clamp(150px, 80vw, 400px)"}>
        <FormControl isRequired m={"20px 0"} isInvalid={newPasswordError !== ""}>
          <FormLabel fontSize={16} fontWeight={600} textTransform={"capitalize"}>New Password
          </FormLabel>
          <Input id={"newPassword"} type={`${eyeStatus ? "password" : "text"}`} placeholder="Enter your password"
                 value={newPassword} required pos={"relative"}
                 onChange={(e) => setNewPassword(e.target.value)}/>
          <Box pos={"absolute"} zIndex={"docked"} top={"40px"} right={"15px"} cursor={"pointer"}>
            <i className={`${eyeStatus ? "fas fa-eye" : "fas fa-eye-slash"}`} onClick={() => revealPassword()}/>
          </Box>
          <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{newPasswordError}</FormErrorMessage>
        </FormControl>
        <FormControl isRequired m={"20px 0"} isInvalid={retypePasswordError !== ""}>
          <FormLabel fontSize={16} fontWeight={600} textTransform={"capitalize"}>Re-type New Password
          </FormLabel>
          <Input id={"retypePassword"} type={"password"} placeholder="Retype your password"
                 value={retypePassword}
                 required pos={"relative"}
                 onBlur={() => onLostFocus()}
                 onChange={(e) => setRetypePassword(e.target.value)}/>
          <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{retypePasswordError}</FormErrorMessage>
        </FormControl>
        <Button type={"submit"} bgColor={"brand.darkGreen"} color={"brand.white"} textTransform={"capitalize"}
                onClick={(e) => onSubmit(e)}>Change
          Password</Button>
      </Flex>
    </Flex>
  );
}

export default TeacherChangePassword;